// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__o7F8D","bar":"Progress_bar__hrqZC","label":"Progress_label__-kwOz"};